module.exports = __webpack_public_path__ + "img/CH.d56d9cef.png";